export default [
  {
    title: "Mis Formularios",
    icon: "FileTextIcon",
    route: "provider-forms",
    action: "read",
    resource: "provider-forms",
  },
];
